<template>
    <main class="container receive-submit">
       <div class="evaluate-logo">
          <img :src="defaultImg + logoImg"/>
       </div>
       <div class="search-wrap">
          <i class="iconfont icon-sousuo"></i>
          <input placeholder="淘宝APP完成评价后，粘贴订单编号~" v-model="orderNumber" @blur="orderNumberBlur" type="number" pattern="\d*"/>
          <span class="submit-btn" @click="submitOrderNumber">提交</span>
       </div>
       <div class="check-order" @click="showCourse"><span>如何提交订单号？</span></div>
    </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config/index'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { mapGetters } from 'vuex'
import {
  LoginSubmitEvaluateOrder,
  NoLoginSubmitEvaluateOrder
} from '@/api/evaluate'
export default {
  data () {
    return {
      defaultImg: IMG_BASE_URL,
      orderNumber: '',
      logoImg: '/upaiyun/Sys/20190109/5367376449692522888.png'
    }
  },
  computed: {
    ...mapGetters([
      'loginState'
    ])
  },
  mounted () {
  },
  methods: {
    submitOrderNumber () {
      if (!this.orderNumber) {
        Toast('订单号不能为空')
        return
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      if (this.loginState) {
        // 已注册
        LoginSubmitEvaluateOrder({ orderNo: this.orderNumber }).then(res => {
          Indicator.close()
          // 领取页面
          this.$router.push({
            name: 'luckdraw',
            query: {
              orderNum: this.orderNumber
            }
          })
        }).catch(res => {
          Indicator.close()
          this.handleException(res.ErrMsg)
        })
      } else {
        // 未注册
        NoLoginSubmitEvaluateOrder({ orderNo: this.orderNumber }).then(res => {
          Indicator.close()
          this.$router.push({
            name: 'orderCheckout',
            query: {
              phoneNum: res.Data,
              orderNum: this.orderNumber
            }
          })
        }).catch(res => {
          Indicator.close()
          this.handleException(res.ErrMsg)
        })
      }
    },
    handleException (errMsg) {
      let infoMsg = ''
      let isContact = 0
      // 1:我知道了 2:联系客服 我知道了3：我知道了 前往注册
      if (errMsg === '订单重复') {
        infoMsg = '该笔订单已领取过了，无法重复领取'
        isContact = 1
      } else if (errMsg === '无法查询到该笔订单') {
        infoMsg = '无法查询到该笔订单，如有疑问请点击下方联系客服'
        isContact = 2
      } else if (errMsg === '商家授权过期') {
        infoMsg = '无法查询到商家信息，请联系客服进行核实'
        isContact = 2
      } else if (errMsg === '商家已停止评价推广') {
        if (this.loginState) {
          infoMsg = '很抱歉，商家已停止评价推广，评价无法获得奖励'
          isContact = 1
        } else {
          infoMsg = '很抱歉，商家已停止评价推广，现在立即注册也可以获得一张免单卡哦~'
          isContact = 3
        }
      } else if (errMsg === '订单尚未评价') {
        infoMsg = '订单尚未评价哦，请前往淘宝APP完成评价后，即可回来领取免单机会~'
        isContact = 1
      } else if (errMsg === '收货人与会员名不一致') {
        infoMsg = '收货人号码与会员名不一致，无法领取奖励。如有疑问，请联系客服'
        isContact = 2
      } else {
        Toast(errMsg)
      }
      if (isContact === 1) {
        MessageBox({
          title: '提示',
          message: infoMsg,
          showCancelButton: false,
          confirmButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        })
      } else if (isContact === 2) {
        MessageBox({
          title: '提示',
          message: infoMsg,
          showCancelButton: true,
          confirmButtonText: '我知道了',
          cancelButtonText: '联系客服',
          confirmButtonClass: 't_f23030'
        }).then(action => {
          if (action === 'cancel') {
            this.$router.push({
              name: 'posterDetail',
              query: {
                isContact: 1
              }
            })
          }
        })
      } else {
        MessageBox({
          title: '提示',
          message: infoMsg,
          showCancelButton: true,
          confirmButtonText: '前往注册',
          cancelButtonText: '我知道了',
          confirmButtonClass: 't_f23030'
        }).then(action => {
          if (action === 'confirm') {
            this.$router.push({
              name: 'my'
            })
          }
        })
      }
    },
    showCourse () {
      this.$router.push({
        name: 'courseStep',
        query: {
          indexStep: 4
        }
      })
    },
    orderNumberBlur () {
      setTimeout(function () {
        window.scrollTo(0, 0)
      }, 100)
    }
  }
}
</script>

<style scoped>
/* #409fff */
.container{
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #fff;
}
.receive-submit .evaluate-logo{
    width: 100%;
    margin-top: 50%;
    text-align: center;
}
.evaluate-logo img{
    width: 60%;
}
.receive-submit .search-wrap{
  width: 88%;
  height: 40px;
  margin: 0 auto;
  background: #f2f2f2;
  border-radius: 20px;
  display: flex;
  align-content: center;
}
.search-wrap > i {
    align-self: center;
    color: #409fff;
    margin: 0 6px;
    font-size: 18px;
    font-weight: bold;
}
.search-wrap > input {
    background: transparent;
    flex: 1;
    padding-right: 6px;
    box-sizing: border-box;
    font-size: 12px
}
.search-wrap .submit-btn {
  line-height: 40px;
  background: #409fff;
  color: #fff;
  padding: 0 12px;
  border-radius: 0 20px 20px 0;
}
.receive-submit .check-order{
  margin-top:20px;
  font-size: 13px;
  color:  #409fff;
  text-align: center;
}
</style>
